import { TConfig, TConfigInput, TConfigParams } from '@@/auto/interfaces';

import { featureFlag } from '../../featureFlags';

function ToyotaORConfig({
  isFeatureEnabled,
}: TConfigParams): DeepPartial<TConfigInput> {
  return isFeatureEnabled(featureFlag.IS_OR_TAI_EXPANSION_ENABLED)
    ? {
        excludeDriversViewConfig: (
          excludeDriversViewConfig: TConfig['excludeDriversViewConfig']
        ) => ({
          ...excludeDriversViewConfig,
          explanationText:
            'An excluded driver will have no coverage or will have a reduction in coverage, depending on the type of coverage, when driving any vehicle listed on the policy. If you choose not to exclude this driver, you will not be eligible for coverage with Toyota.',
        }),
      }
    : {};
}
export default ToyotaORConfig;
